export function abortSignalAbort(reason) {
    const controller = new AbortController();
    controller.abort(reason);
    return controller.signal;
}
/*#__PURE__*/
export function isSupported() {
    return ('abort' in AbortSignal &&
        // @ts-expect-error `.abort`
        typeof AbortSignal.abort === 'function');
}
/*#__PURE__*/
export function isPolyfilled() {
    // @ts-expect-error `.abort`
    return AbortSignal.abort === abortSignalAbort;
}
export function apply() {
    if (!isSupported()) {
        // @ts-expect-error `.abort`
        AbortSignal.abort = abortSignalAbort;
    }
}
//# sourceMappingURL=abortsignal-abort.js.map